import { Component } from '@angular/core';
import { ACDATAConnectorPanel } from '../a.cdata.connector.panel';
import { CDATAConnectorInfo } from '../../../../../../../models/datamodel/adbinfo.model';

@Component({
    selector: 'sapgateway-connector-panel',
    templateUrl: './sapgateway.connector.panel.html'
})
export class SAPGatewayConnectorPanel extends ACDATAConnectorPanel {
    static GetInfo(): CDATAConnectorInfo {
        return {
            Caption: '@@SAP Gateway',
            Type: 'evidanza.Database.CData.CDataConnector.ConnectorsInfo.SAPGatewayInfo',
            ControlType: SAPGatewayConnectorPanel,
            Default: {
                UseSSL : true
            }
        };
    }
}
